export default [
  {
    path: '/main/frotix-management/vehicle-evolution',
    meta: {
      tag: 'frotix_management_vehicle_evolution',
      name: 'Evolução de veículos por cliente',
      breadcrumb: 'Evolução de veículos por cliente'
    },
    component: () => import(/* webpackChunkName: "vehicle-evolution" */ '@/views/main/frotix-management/vehicle-evolution/Index.vue'),
    children: [
      {
        path: '',
        name: 'listvehiceevolution',
        meta: {
          tag: 'frotix_management_vehicle_evolution',
          menu: 'frotix_management',
          name: 'Evolução de veículos por cliente'
        },
        component: () => import(/* webpackChunkName: "vehicle-evolution" */ '@/views/main/frotix-management/vehicle-evolution/List.vue'),
      }
    ]
  }
]
